
import * as THREE from 'three'

import { LoadGLTFOptions} from '../types'

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'


const DECODER_PATH = 'draco/'


function decodeDraco(loader: GLTFLoader): GLTFLoader {
  const dracoloader = new DRACOLoader()

  try {
    dracoloader.setDecoderPath(DECODER_PATH)
    dracoloader.setDecoderConfig({ type: 'js' })
    dracoloader.preload()
    loader.setDRACOLoader(dracoloader)
  } catch (err) {
    console.debug("DRACO Compression failed", err)
  }
  return loader
}


/**
 * Load GLTF/GLB model
 */
export const loadGLTFModel = (
  path: string,
  options: LoadGLTFOptions = {}
): void => {
  const onLoad = options.onLoad || null

  let loader = new GLTFLoader()

  // Decode loader (draco mesh compression)
  if (options.draco === true) {
    console.debug("draco compression ON")
    loader = decodeDraco(loader)
  }

  // Load the resource
  if (!path) {
    console.warn("no path specified for gltf model")
    return
  }

  loader.load(
    path,
    // On load
    (gltf) => {
      const model = gltf.scene

      if (onLoad) {
        onLoad(gltf, options)
      } else {
        console.debug("no loading callback specified on gltf model")
      }

      model.traverse((object) => {
        if ((object as THREE.Mesh).isMesh) {
          object.castShadow = false
        }
      })

      console.log('model loaded:', model)
    },

    // On progress
    (xhr) => {
      console.debug('Loading', path, (xhr.loaded / xhr.total * 100).toFixed(1) + '% loaded')
    },

    // On error
    (error) => {
      console.warn("Error loading '" + path + "': " + error)
    }
  )
}
